'use client'

import { type ReadonlyURLSearchParams, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { gtmDataLayerPush } from '../../gtm'
import { urlResolverGetAccountOrders } from '../../url-handling'

const ORIGIN_PAGE = 'help-center'

export const getContext = (
  searchParams: ReadonlyURLSearchParams,
  orderUrl: string,
): string => {
  if (searchParams.get('source') === ORIGIN_PAGE) {
    return 'amazonisation'
  }

  if (typeof document !== 'undefined' && document.referrer.includes(orderUrl)) {
    return 'order'
  }

  return 'other'
}

export const useDirectContactCsHotlinePushFullStoryTracking = (): void => {
  const hasTrackedRef = useRef(false)

  const config = useGlobalConfigContext()
  const orderUrl = urlResolverGetAccountOrders(config)
  const searchParams = useSearchParams()

  useEffect(() => {
    if (hasTrackedRef.current) {
      return
    }

    const context = getContext(searchParams, orderUrl)

    gtmDataLayerPush({
      event: 'fs_page_prop',
      fs_page_properties: {
        context,
        pageName: 'cs_hotline',
      },
    })
    hasTrackedRef.current = true
  }, [orderUrl, searchParams])
}
